import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { bindActionCreators } from 'redux';
import queryString from 'query-string';
import snakeCaseKeys from 'snakecase-keys';
import { connect } from 'react-redux';
import { DesktopRightSidebar } from 'shared/components/BannerAll';
import { setDataLayer } from 'shared/actions/globals';
import cx from 'classnames';
import { withFetch } from 'shared/hocs/withFetch';
import * as formActions from 'shared/actions/searchForm';
import API from 'shared/constants/api';
import { Googletag } from 'shared/modules';
import SeoLinks from 'shared/components/SeoLinks/SeoLinks';
import CanonicalLinks from 'desktop/components/CanonicalLinks/CanonicalLinks';
import PageTitle from 'desktop/components/PageTitle/PageTitle';
import DealerAdvertsAds from 'desktop/components/DealerAdvertsAds/DealerAdvertsAds';
import Paginate from 'desktop/components/Paginate/Paginate';
import TopCars from 'desktop/components/TopCars/TopCars';
import MakesSidebar from 'desktop/components/MakesSidebar/MakesSidebar';
import SearchBarV2 from 'desktop/components/SearchBarV2/SearchBarV2';
import SpecialAdverts from './../home/components/SpecialAdverts/SpecialAdverts';
import CarsList from './components/CarsList/CarsList';
// import SearchBar from './components/SearchBar/SearchBar';
import SortLine from './components/SortLine/SortLine';
import SPECIAL from '../../constants/special';

// eslint-disable-next-line
import s from './Search.css';

const fetchDealerCars = (fetch, params) => {
  const { yearFrom, yearTo, priceFrom, priceTo, page, ...filteredParams } = params;

  return fetch(
    API.ADVERT.ALL(
      `?${queryString.stringify(
        snakeCaseKeys({
          perPage: 16,
          ...(filteredParams || {}),
          isNew: 1,
          isHot: 1,
          fromDealer: 1,
        }),
      )}`,
    ),
  ).then(r => r.json());
};

class Search extends React.Component {
  static propTypes = {
    carsResult: PropTypes.shape().isRequired,
    currency: PropTypes.shape().isRequired,
    currentPage: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    transportType: PropTypes.shape().isRequired,
    canonicalList: PropTypes.arrayOf(PropTypes.shape()),
    formData: PropTypes.shape().isRequired,
    formVocabulary: PropTypes.shape().isRequired,
    avtoSelectedActions: PropTypes.shape().isRequired,
    motoSelectedActions: PropTypes.shape().isRequired,
    commercialSelectedActions: PropTypes.shape().isRequired,
    formState: PropTypes.shape().isRequired,
    // formResults: PropTypes.shape().isRequired,
    carsListTypes: PropTypes.shape().isRequired,
    query: PropTypes.shape().isRequired,
    fullQuery: PropTypes.shape().isRequired,
    pageQuery: PropTypes.shape().isRequired,
    url: PropTypes.string.isRequired,
    location: PropTypes.shape(),
    title: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.shape()]).isRequired,
    isMotoSearch: PropTypes.bool,
    isCommercial: PropTypes.bool,
    count: PropTypes.number,
    isLoading: PropTypes.bool,
    seoCharacteristics: PropTypes.shape().isRequired,
    specialCars: PropTypes.shape(),
    //
    fetch: PropTypes.func.isRequired,
  };
  static defaultProps = {
    canonicalList: [],
    specialCars: null,
    location: null,
    count: 0,
    isMotoSearch: false,
    isCommercial: false,
    isLoading: false,
  };
  state = {
    dealersCars: null,
    scroll: 0,
  };

  componentDidMount() {
    const { fullQuery } = this.props;
    if (!fullQuery.isNew) {
      this.fetchDealerCars();
    }
  }

  componentDidUpdate(prevProps) {
    if (JSON.stringify(this.props.fullQuery) !== JSON.stringify(prevProps.fullQuery)) {
      const { fullQuery } = this.props;

      if (!fullQuery.isNew) {
        this.fetchDealerCars();
      }
    }
  }

  fetchDealerCars = () => {
    const { fullQuery, fetch } = this.props;

    this.setState({ dealersCars: null, isFetching: true });

    fetchDealerCars(fetch, fullQuery).then(cars =>
      this.setState({ dealersCars: cars.results, isFetching: false }),
    );
  };

  render() {
    const {
      carsResult,
      carsListTypes,
      avtoSelectedActions,
      motoSelectedActions,
      commercialSelectedActions,
      formData,
      formState,
      // formResults,
      formVocabulary,
      currentPage,
      transportType,
      canonicalList,
      currency,
      query,
      location,
      pageQuery,
      url,
      title,
      isMotoSearch,
      isCommercial,
      fullQuery,
      isLoading,
      count,
      seoCharacteristics,
    } = this.props;

    const { dealersCars } = this.state;
    const carsResults = {};
    Object.keys(carsListTypes).forEach(key => {
      carsResults[key] = carsResult[key];
    });
    const { result, top, vip } = carsResults;

    const visibleTops = Array.isArray(top) ? top : [];
    const carsList = [
      ...visibleTops,
      ...(result && result.results ? result.results : []).filter(
        item => !visibleTops.map(t => t.id).includes(item.id),
      ),
    ];

    const pageCount = Math.ceil(count / 20);

    let selectedActions = avtoSelectedActions.selectedActions;
    let page = 'search';
    if (isMotoSearch) {
      selectedActions = motoSelectedActions.selectedActions;
      page = 'moto-search';
    }
    if (isCommercial) {
      selectedActions = commercialSelectedActions.selectedActions;
      page = 'commercial';
    }

    const linkPrefixParams = {
      make: query.make,
      model: query.model,
      isNew: query.isNew,
      transport: transportType,
    };

    const shouldDisplayDealerAdverts =
      fullQuery &&
      !fullQuery.isNew &&
      carsList &&
      carsList.length > 10 &&
      dealersCars &&
      dealersCars.length > 0;

    const dealerAdverts = shouldDisplayDealerAdverts ? (
      <DealerAdvertsAds
        key={JSON.stringify(fullQuery)}
        cars={dealersCars && dealersCars.slice(0, 8)}
      />
    ) : (
      undefined
    );

    return (
      <div className={s.page}>
        <div className={s.container}>
          <div className={s.flexRow}>
            <div className={s.searchContainer}>
              <SearchBarV2
                transportType={transportType}
                count={result.count}
                selectedActions={selectedActions}
                formState={formState}
                formData={formData}
                formVocabulary={formVocabulary}
                page={page}
                isCommercial={isCommercial}
                isLoading={isLoading}
              />

              {canonicalList && canonicalList.length > 0 && (
                <CanonicalLinks
                  key={transportType.id}
                  canonicalList={canonicalList}
                  query={query}
                  location={location}
                  transportType={transportType}
                />
              )}
            </div>
          </div>
        </div>
        <div className={s.container}>
          <div className={s.flexRow}>
            <div className={cx(s.flexCell, s.mainCell)}>
              {/* <SearchBar
                transportType={transportType}
                count={result.count}
                selectedActions={selectedActions}
                formState={formState}
                formData={formData}
                formVocabulary={formVocabulary}
                page={page}
                isCommercial={isCommercial}
                isLoading={isLoading}
              /> */}
              {/* {canonicalList &&
                canonicalList.length > 0 &&
                <CanonicalLinks
                  key={transportType.id}
                  canonicalList={canonicalList}
                  query={query}
                  location={location}
                  transportType={transportType}
                />} */}
              <div
                // eslint-disable-next-line
                className={s.advertContainerGl}
              >
                <Googletag id="div-gpt-ad-1510239331518-2" />
              </div>
              <PageTitle title={title} />
              <SortLine />
              {vip && vip.length > 0 && <TopCars cars={vip} currency={currency} />}

              <CarsList
                afterFourthSlot={dealerAdverts}
                cars={carsList}
                currency={currency}
                currentPage={currentPage}
                title={title}
              />

              <SortLine />

              {this.props.specialCars && (
                <SpecialAdverts
                  cars={this.props.specialCars}
                  specialLinks={SPECIAL.LOW_PRICE_ONLY}
                />
              )}

              {shouldDisplayDealerAdverts && (
                <DealerAdvertsAds
                  key={JSON.stringify(fullQuery)}
                  cars={dealersCars && dealersCars.slice(8, 16)}
                />
              )}

              {carsList && carsList.length > 0 && (
                <Paginate
                  url={url}
                  query={pageQuery}
                  pageCount={pageCount}
                  initialPage={currentPage}
                />
              )}
              <SeoLinks
                linkPrefixParams={linkPrefixParams}
                location={location}
                characteristics={seoCharacteristics}
              />
            </div>
            <DesktopRightSidebar>
              <MakesSidebar />
            </DesktopRightSidebar>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  formState: state.searchForm.selected,
  // formResults: state.searchForm.results,
  formData: state.searchForm.data,
  formVocabulary: state.searchForm.vocabulary,
  count: state.searchForm.data.count,
});

const utilActions = dispatch => ({
  toggle: bindActionCreators(formActions.selectedActions.toggle, dispatch),
  clear: bindActionCreators(formActions.selectedActions.clear),
  clearForm: bindActionCreators(formActions.carSetThunks.clearSelected, dispatch),
});

const mapDispatchToProps = dispatch => ({
  avtoSelectedActions: {
    selectedActions: {
      set: bindActionCreators(
        {
          ...formActions.selectedActions.set,
          ...formActions.carSetThunks,
          ...formActions.setData,
        },
        dispatch,
      ),
      ...utilActions(dispatch),
    },
  },
  motoSelectedActions: {
    selectedActions: {
      set: bindActionCreators(
        {
          ...formActions.selectedActions.set,
          ...formActions.motoSetThunks,
          ...formActions.setData,
        },
        dispatch,
      ),
      ...utilActions(dispatch),
    },
  },
  commercialSelectedActions: {
    selectedActions: {
      set: bindActionCreators(
        {
          ...formActions.selectedActions.set,
          ...formActions.commercialSetThunks,
          ...formActions.setData,
        },
        dispatch,
      ),
      ...utilActions(dispatch),
    },
  },
  setDataLayer,
});

export default withStyles(s)(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(withFetch(Search)),
);



// WEBPACK FOOTER //
// ./src/desktop/routes/search/Search.js